import {
  isNil,
  isFunction,
} from 'lodash-es'
import logger from '../logger'
import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'

// ////////////////////////////////
// Element Animation Transition //
// ////////////////////////////////

export default {
  init() {
    logger('init CrossSlideInputTransition', 'debug')()
  },
  crossSlideIn(oldEl, newEl, commonParentEl, cb, options = {}) {
    logger('revealing element', 'debug')()

    if (!oldEl) throw new Error('Old element required as argument 1. None found')
    if (!newEl) throw new Error('New element required as argument 2. None found')
    if (!commonParentEl) throw new Error('Common parent element required as argument 3. None found')

    // set the item to invisible to begin with
    let parentSequence

    // target all DOM nodes
    const $oldEl = this.root.querySelector(oldEl)
    const $newEl = this.root.querySelector(newEl)
    const $commonParentEl = this.root.querySelector(commonParentEl)

    if (isNil($oldEl)) throw new Error(`Old element not found in DOM: '${oldEl}'. Exiting`)
    if (isNil($newEl)) throw new Error(`New element not found in DOM: '${newEl}'. Exiting`)
    if (isNil($commonParentEl)) throw new Error(`Common parent element not found in DOM: '${commonParentEl}'. Exiting`)

    const DURATION = options.duration || 250
    const MAXHEIGHT = options.maxHeight

    if (isNil($oldEl) || isNil($newEl)) {
      logger('CrossSlideInputTransition doesn\'t have elements', 'error')()
      return
    }

    // Get the width that everything should be set to
    const oldElementWidth = $oldEl.offsetWidth
    const newElementWidth = $newEl.offsetWidth

    // get the height of the common parent before the second node
    // is added by positioning it absolutely
    $commonParentEl.style.setProperty('position', 'relative')

    $newEl.style.setProperty('opacity', '0')
    $newEl.style.setProperty('position', 'absolute')
    $newEl.style.setProperty('top', '0')
    $newEl.style.setProperty('left', '0')
    $newEl.style.setProperty('width', `${oldElementWidth}px`)
    $newEl.style.setProperty('z-index', $commonParentEl.style.zIndex + 2)

    $oldEl.style.setProperty('width', `${newElementWidth}px`)

    // Get calculated height values
    const newElementHeight = $newEl.offsetHeight
    const newAnimationHeight = newElementHeight > MAXHEIGHT ? MAXHEIGHT : newElementHeight
    const oldElementHeight = $commonParentEl.offsetHeight

    // Position new element relative to parent so that it doesn't jump to the right
    $newEl.style.setProperty('position', 'inherit')

    // Set both the primary and the secondary to the appropriate width
    // and position the primary absolutely
    $oldEl.style.setProperty('position', 'absolute')
    $oldEl.style.setProperty('top', '0')
    $oldEl.style.setProperty('left', '0')
    $oldEl.style.setProperty('z-index', $commonParentEl.style.zIndex + 1)
    $oldEl.style.setProperty('width', `${oldElementWidth}px`)

    // set the height of the parent to prevent jumping
    $commonParentEl.style.setProperty('height', `${oldElementHeight}px`)

    // animate the parent to the new height
    if (oldElementHeight >= newAnimationHeight) {
      parentSequence = [{
        e: $commonParentEl,
        p: {
          height: newAnimationHeight,
        },
        o: {
          duration: DURATION,
          delay: DURATION * 0.6,
          easing: 'easeInOutQuint',
        },
      }]
    } else {
      parentSequence = [{
        e: $commonParentEl,
        p: {
          height: newAnimationHeight,
        },
        o: {
          duration: DURATION,
          easing: 'easeInOutQuint',
        },
      }]
    }

    Velocity.RunSequence(parentSequence)

    const childrenSequence = [{
      e: $oldEl,
      p: {
        opacity: 0,
      },
      o: {
        duration: DURATION,
        easing: 'linear',
      },
    }, {
      e: $newEl,
      p: {
        opacity: 1,
      },
      o: {
        duration: DURATION,
        easing: 'linear',
        complete: () => {
          const $input = $newEl.querySelector('input')
          if ($input) $input.focus()
          // reset $oldEl
          $oldEl.style.setProperty('position', 'inherit')
          $oldEl.style.setProperty('width', 'inherit')

          $newEl.style.setProperty('position', 'inherit')
          $newEl.style.setProperty('width', 'inherit')

          $commonParentEl.style.setProperty('height', newElementHeight > MAXHEIGHT ? `${MAXHEIGHT}px` : 'inherit')

          if (newElementHeight > MAXHEIGHT) $commonParentEl.classList.add('content-scroll')

          if (isFunction(cb)) cb.call(this)
        },
      },
    }]

    Velocity.RunSequence(childrenSequence)
  },
}
